export default __webpack_public_path__ + "static/media/Mendoza.c9f76459.svg";